<template>
	<div>

		<el-table :data="tableData" size="mini" style="width: 100%;margin-bottom: 20px;" border @sort-change="changeTableSort" @selection-change="handleSelectionChange" stripe>
			<el-table-column type="selection" width="55" v-if="multSelect">
			</el-table-column>
			<el-table-column prop="flag" v-if="$store.state.pmid==2" width="80" label="录取状态">
			</el-table-column>
			<!-- <el-table-column prop="stu_code" v-else width="110" label="学生编号">
			</el-table-column> -->
			<el-table-column prop="stu_idx" v-if="$store.state.pmid==4" width="110" label="报道须知号" sortable="custom">
				<template slot-scope="scope">
					{{get3Num(scope.row.stu_idx)}}
				</template>
		
			</el-table-column>
			<el-table-column prop="stu_name" label="姓名" width="100" sortable="custom"></el-table-column>
	
			<el-table-column prop="exam_num" label="准考证号" width="120"></el-table-column>
			<el-table-column prop="exam_score" label="总分" width="80" sortable="custom"></el-table-column>
			<el-table-column prop="volunteer" label="志愿" width="80">
				<template slot-scope="scope">

			
					<span v-if="scope.row.volunteer==1">第一志愿</span>
					<span v-if="scope.row.volunteer==2">第二志愿</span>
					<span v-if="scope.row.volunteer==3">第三志愿</span>
					<span v-if="scope.row.volunteer==0">无志愿</span>
				</template>
			</el-table-column>
			<el-table-column prop="gender" label="性别" width="80"  sortable="custom">
				<template slot-scope="scope">
			
					<span v-if="scope.row.gender==1">男</span>
					<span v-if="scope.row.gender==2">女</span>
			
					<span v-if="scope.row.gender==0">未知</span>

				</template>
			</el-table-column>
			<el-table-column prop="graduate_sch_city" label="地区" width="150"></el-table-column>
			<el-table-column prop="yuanxi_name" label="系部" width="120"></el-table-column>


			<el-table-column prop="major_code" label="专业代码" min-width="80"></el-table-column>
      <el-table-column prop="major_name" label="专业名称" min-width="140"></el-table-column>

			<el-table-column prop="class_name" label="班级" min-width="100"></el-table-column>
			<el-table-column prop="class_name" v-if="$store.state.pmid==1" label="完善信息" width="80">
				<template slot-scope="scope">

					<span v-if="scope.row.wanshan">已完善</span>
					<span v-else style="color: #007AFF; cursor: pointer;">
						未完善
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="class_name" label="住宿" width="60">
				<template slot-scope="scope">

							
					<span v-if="scope.row.dorm==1">是</span>	
					<span v-else>否</span>
					

				</template>
			</el-table-column>
			<el-table-column prop="class_name" label="缴费金额" width="80">
				<template slot-scope="scope">

							
					<span >{{scope.row.total_money}}</span>	
					
					
				</template>
			</el-table-column>
			
			<el-table-column v-if="!$store.state.exprise"  prop="phone" label="联系方式" min-width="120"></el-table-column>
			<el-table-column prop="status" label="状态" width="80">
				<template slot-scope="scope">
					<span v-if="scope.row.status==1" style="color: green;">已审核</span>
					<span v-if="scope.row.status==2"  style="color: blue;">已缴费</span>
					<span v-if="scope.row.status==3"  style="color: deepskyblue;">未分班</span>
					<span v-if="scope.row.status==4"  style="color: #096DD9;">已分班</span>
					<span v-if="scope.row.status==-1" style="color: orangered;">不通过</span>
					<span v-if="scope.row.status==-2" style="color: orangered;">已退档</span>
					<span v-if="scope.row.status==0"  style="color: gray;">未审核</span>
				</template>
			</el-table-column>
			<el-table-column v-if="!$store.state.exprise"  prop="username" label="录入员" width="100"></el-table-column>
			<el-table-column v-if="!$store.state.exprise"  prop="cdate" label="录入时间" width="150"></el-table-column>
			

			<el-table-column v-if="!$store.state.exprise"  fixed="right" label="操作" width="120">

				<template slot-scope="scope">
					<!-- <el-popconfirm width="200" confirmButtonText='确定' cancelButtonText='取消' icon="el-icon-info" iconColor="red"
					 @confirm="handleDel(scope.row)" placement="left" title="是否确定删除？">
						<a slot="reference" size="small" style="color: red;font-size: 12px;margin-right: 10px;">删除</a>
					</el-popconfirm> -->

					<!-- <el-button @click="handleModify(scope.row)" v-if="scope.row.status<3" type="text" size="small">审核</el-button>
					<el-button @click="handleModify(scope.row)" v-else type="text" size="small">查看</el-button> -->
					<el-button @click="handleModify(scope.row)"  type="text" size="small">查看</el-button>
					<el-button @click="handleCancelTH(scope.row.id)" v-if="scope.row.status==-2" type="text" size="small">取消退档</el-button>
					
					
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="handlePageChange" :current-page="page.pageIndex" :page-size="page.pageSize" layout="total, prev, pager, next, jumper"
		 :total="page.total">

		</el-pagination>
	</div>
</template>
<script>
export default {
	name: 'Table',
	data() {
		return {}
	},
	props: {
		page: {
			type: Object,
		},
		tableData: {
			type: Array,
			default: []
		},
		from: {
			type: String,
			default: ''
		},
		multSelect: {
			type: Boolean,
			default: true
		},
	},
	methods: {
		handleModify(row) {
			this.$emit('handleModify', row)
		},
		handleDel(row) {
			this.$emit('handleDel', row)
		},
		handleSelectionChange(val) {
			this.$emit('handleSelectionChange', val)
		},
		handlePageChange(e) {
			this.$emit('handlePageChange', e)
		},
		changeTableSort(column) {
			this.$emit('changeTableSort', column)

		},
		handleCancelTH(id) {
			this.$confirm('取消退档后会进入已录取未分班状态, 是否取消退档?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post("/api/t_sch_student_sp", {
					ids: id,
					status: 3
				}).then(res => {
					if (res.data.code == 200) {
						this.$message.success('取消退档成功')

						this.$emit('handlePageChange', 1)
					} else {
						if (res.data.sqlMessage) {
							this.$message.error(res.data.sqlMessage)
						} else {
							this.$message.error(res.data.msg)
						}

					}

				})


			}).catch(() => {
				
			});
		}

	}
}
</script>
